import { render, staticRenderFns } from "./chooseGroup.vue?vue&type=template&id=25ab6cd8&scoped=true&"
import script from "./chooseGroup.vue?vue&type=script&lang=ts&"
export * from "./chooseGroup.vue?vue&type=script&lang=ts&"
import style0 from "./chooseGroup.vue?vue&type=style&index=0&id=25ab6cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab6cd8",
  null
  
)

export default component.exports